import * as Yup from 'yup';

export default Yup.object().shape({
    value: Yup.string().required(),
});